export const actionMode = {
  edit: 'edit',
  new: 'new',
};

export default actionMode;
